export default function AssetIcon(props) {
  return (
    <svg
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      {...props}
    >
      <mask
        id="mask0_1_4"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <path d="M14 8V1C14 0.447715 13.5523 0 13 0H5C4.44772 0 4 0.447715 4 1V4H1C0.447715 4 0 4.44772 0 5V18H8V15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15V18H18V9C18 8.44772 17.5523 8 17 8H14ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM12 12H10V10H12V12ZM12 8H10V6H12V8ZM12 4H10V2H12V4ZM16 16H14V14H16V16ZM16 12H14V10H16V12Z" />
      </mask>
      <g mask="url(#mask0_1_4)">
        <path d="M14 8V1C14 0.447715 13.5523 0 13 0H5C4.44772 0 4 0.447715 4 1V4H1C0.447715 4 0 4.44772 0 5V18H8V15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15V18H18V9C18 8.44772 17.5523 8 17 8H14ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM12 12H10V10H12V12ZM12 8H10V6H12V8ZM12 4H10V2H12V4ZM16 16H14V14H16V16ZM16 12H14V10H16V12Z" />
        <path d="M21 -2.7H-3V21.3H21V-2.7Z" />
      </g>
    </svg>
  )
}
